import { axiosCall } from "../../../lib/ec2-api-lib";
import { getPayRecords } from "../../../lib/pay-api-lib";
import { updateOrderStatus, delOrderStatus, getOrderStatusList } from "../../../lib/ec2-api-lib";
import { payApi, onlposApi } from "../../../settings/appSetting";
import { tsId } from "../../../lib/utils";

const payServerUrl = payApi.debug ? payApi.endpoint_debug : payApi.endpoint_public
const onlposServerHost = onlposApi.debug ? onlposApi.endpoint_debug : onlposApi.endpoint_public

// /** @deprecated */
// export const addOrderStatus = async ({ shopId, orderId, body }) => {
//   let path = `/pos/order-status/order?shopId=${shopId}`;
//   path += `&orderId=${orderId}`;
//   return await axiosCall({ method: "POST", path, body });
// };

// /** @deprecated */
// export const createOnlOrderStatus = async ({ shopInfo, shopId, tableCode, body }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   const newShopId = "ONLPOS-" + shopInfo.shopId
//   let path = `/pos/order-status/order?shopId=${newShopId}`;
//   path += `&orderId=${tableCode}`;
//   return await axiosCall({ method: "POST", path, body });
// };

// /** @deprecated */
// export const updateOnlOrderStatus = async ({ shopInfo, shopId, tableCode, body }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   const newShopId = "ONLPOS-" + shopInfo.shopId
//   let path = `/pos/order-status/order?shopId=${newShopId}`;
//   path += `&orderId=${tableCode}`;
//   return await axiosCall({ method: "PUT", path, body });
// };

// /** @deprecated */
// export const deleteOnlOrderStatus = async ({ shopInfo, shopId, tableCode }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   const newShopId = "ONLPOS-" + shopInfo.shopId
//   let path = `/pos/order-status/order?shopId=${newShopId}`;
//   path += `&orderId=${tableCode}`;
//   return await axiosCall({ method: "DELETE", path });
// };

// /** @deprecated */
// export const getOnlOrderStatusList = async ({ shopInfo, shopId }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   const newShopId = "ONLPOS-" + shopInfo.shopId
//   let path = `/pos/order-status/list?shopId=${newShopId}`;
//   return await axiosCall({ method: "GET", path });
// };

// /**@OrderStatus */

// /** @deprecated */
// export const onlposCreateOrderStatus = async ({ shopInfo, tableCode, body }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   let path = `/pos/order-status/order?shopId=${getNewShopId(shopInfo)}`;
//   path += `&orderId=${tableCode}`;
//   return await axiosCall({ method: "POST", path, body });
// };

// /** @deprecated */
// export const onlposUpdateOrderStatus = async ({ shopInfo, tableCode, body }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   return updateOrderStatus({ shopId: getNewShopId(shopInfo), orderId: tableCode, body })
// };

// /** @deprecated */
// export const onlposDeleteOrderStatus = async ({ shopInfo, tableCode }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   return delOrderStatus({ shopId: getNewShopId(shopInfo), orderId: tableCode })
// };

// /** @deprecated */
// export const onlposGetOrderStatusList = async ({ shopInfo }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   return getOrderStatusList({ shopId: getNewShopId(shopInfo) })
// };

// /**@deprecated */
// export const onlposPayDataCreate = ({ shopInfo, ver, body }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }

//   // 
//   // payDataCreate과 별도의 api임
//   // 
//   let path = `/payment/pay-record/onlpos`;
//   path += `?shopId=${getNewShopId(shopInfo)}&posName=${shopInfo.posName}&ver=${ver}`;
//   return axiosCall({ method: "POST", path, body });
// };

// /**@deprecated */
// export const onlposGetPayRecords = ({ shopInfo, start_time, end_time }) => {
//   if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
//   return getPayRecords({ shopId: getNewShopId(shopInfo), start_time, end_time });
// };

function validatePosname(shopInfo) {
  return (shopInfo?.posName === "ONL_POS")
}

function getNewShopId(shopInfo) {
  return "ONLPOS-" + shopInfo.shopId
}

/** @Send_order_to_ONL_POS by iot publish */
export const sendOrderToONLPOS = ({ shopId, orderData }) => {
  const body = { shopId, orderData }
  const path = `/api/onlpos/order`;
  return axiosCall({ method: "POST", path, body, host: payServerUrl });
}

/** **********************************************************************************
 * @common_apis 
 ********************************************************************************** */

function createQueryFromKey(key) {
  const keys = Object.keys(key)
  let q = ""
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (i === 0) q += `?${k}=${key[k]}`
    else q += `&${k}=${key[k]}`
  }
  return q
}

function createQueryFromFilter(filter) {
  const keys = Object.keys(filter)
  let q = ""
  for (const k of keys) {
    q += `&${k}=${filter[k]}`
  }
  return q
}

export const createItem = ({ model, key, body }) => {
  const host = onlposServerHost
  let path = `/api/db/${model}` + createQueryFromKey(key);
  return axiosCall({ method: "POST", path, body, host });
};

export const getItem = ({ model, key }) => {
  const host = onlposServerHost
  let path = `/api/db/${model}` + createQueryFromKey(key);
  return axiosCall({ method: "GET", path, host });
};

export const listItems = ({ model, key, filter }) => {
  const host = onlposServerHost
  let path = `/api/db/${model}/list` + createQueryFromKey(key);
  if (filter) path += createQueryFromFilter(filter)
  return axiosCall({ method: "GET", path, host });
};

export const updateItem = ({ model, key, body }) => {
  const host = onlposServerHost
  let path = `/api/db/${model}` + createQueryFromKey(key);
  return axiosCall({ method: "PUT", path, body, host });
};

export const deleteItem = ({ model, key }) => {
  const host = onlposServerHost
  let path = `/api/db/${model}` + createQueryFromKey(key);
  return axiosCall({ method: "DELETE", path, host });
};

/** ************************************************************************************
 * @order_status 
 * *************************************************************************************/

export const onlposCreateOrderStatus2 = async ({ shopInfo, tableCode, body }) => {
  return createItem({
    model: "order-status",
    key: { shopId: getNewShopId(shopInfo), orderId: tableCode },
    body
  })
};

export const onlposUpdateOrderStatus2 = async ({ shopInfo, tableCode, body }) => {
  return updateItem({
    model: "order-status",
    key: { shopId: getNewShopId(shopInfo), orderId: tableCode },
    body
  })
};

export const onlposListOrderStatus = async ({ shopInfo }) => {
  return listItems({
    model: "order-status",
    key: { shopId: getNewShopId(shopInfo) }
  })
};

/**@PayRecord */

export const onlposCreatePayData = ({ shopInfo, body }) => {
  if (!validatePosname(shopInfo)) return { err: { message: "Invalid Posname" } }
  const orderId = tsId()
  return createItem({
    model: "pay-record",
    key: { shopId: getNewShopId(shopInfo), orderId },
    body
  })
};

export const onlposListPayRecord = ({ shopInfo, start_time, end_time }) => {
  return listItems({
    model: "pay-record",
    key: { shopId: getNewShopId(shopInfo) },
    filter: { start_time, end_time }
  })
};